/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSeoLinks_viewer$ref: FragmentReference;
export type PdpRespSeoLinks_viewer = {|
  +isMoreWaysToBrowseEnabled: ?boolean,
  +$refType: PdpRespSeoLinks_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSeoLinks_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MORE_WAYS_TO_BROWSE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MORE_WAYS_TO_BROWSE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e46ceba8336e0a341bd5695245941c27';
module.exports = node;
